export const findByPropMatch = (propKey, propVal) => item =>
  item[propKey] === propVal;

export const dropByPropMatch = (propKey, propVal) => item =>
  item[propKey] !== propVal;

export const findById = id => findByPropMatch('id', id);

export const dropById = id => !findById(id);
